// TODO: delete this file and use @livv/utils
/* eslint-disable sort-keys */

import { Languages } from '@livv/models';

const ROMAN_NUMBERS: { [key: string]: number } = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
};

export const convertToRoman = (numRef: number): string =>
    Object.keys(ROMAN_NUMBERS).reduce<[string, number]>(
        ([str, num], romanNb) => {
            const q = Math.floor(num / ROMAN_NUMBERS[romanNb]);

            return [str + romanNb.repeat(q), num - q * ROMAN_NUMBERS[romanNb]];
        },
        ['', numRef],
    )[0];

export const formatNumber = (number: number, lang: Languages): string =>
    number.toLocaleString(lang);

export const displayThousands = (number: number, lang: Languages): string =>
    formatNumber(number > 1000 ? Math.round(number / 1000) * 1000 : number, lang);

/**
 *
 * @param n         Input number
 * @param total     Max number
 * @returns         Percentage of n in total, rounded to nearest 0.5 as a string
 */
export const formatPercentage = (n: number, total?: number): string =>
    total ? `${Math.round((200 * n) / total) / 2}%` : `${Math.round(200 * n) / 2}%`;

/**
 *
 * @param values    Array of number
 * @param sort      Set to false is values are already sorted
 * @returns         Median value of the array
 */
export const getMedianValue = (values: number[], sort = true): number => {
    if (!values.length) {
        return 0;
    }

    const sortedValues = sort ? values.sort((v1, v2) => v1 - v2) : values;

    const medianIndex = Math.floor(sortedValues.length / 2);

    return sortedValues.length % 2
        ? sortedValues[medianIndex]
        : (sortedValues[medianIndex - 1] + sortedValues[medianIndex]) / 2;
};

/**
 *
 * @param values    Array of number
 * @returns         Mean value of given arrray
 */
export const getMeanValue = (values: number[]): number =>
    values.length ? values.reduce((acc, value) => acc + value, 0) / values.length : 0;
